'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoUtils = undefined;

var _video = require('./video');

Object.defineProperty(exports, 'videoUtils', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_video).default;
  }
});
exports.supportsUGCContentType = supportsUGCContentType;

var _constantsUgc = require('@bibliocommons/constants-ugc');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Normalizes ugc types to match UGC_CONTENT_TYPES
function normalizeContentType(type) {
  var normalizeMap = {
    quotation: _constantsUgc.UGC_CONTENT_TYPES.QUOTATIONS,
    private_notes: _constantsUgc.UGC_CONTENT_TYPES.PRIVATE_NOTE
  };

  return normalizeMap[type] || type;
}

/**
 * Determines whether a library supports the given UGC content type.
 * @param {string} type
 * @param {object} library
 * @param {string} localBranch
 * @return {boolean}
 */
function supportsUGCContentType(type, library) {
  var localBranch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var supportedTypes = library.get('ugcContentTypes').map(normalizeContentType);
  if (supportedTypes.indexOf(type) > -1) {
    switch (type) {
      case _constantsUgc.UGC_CONTENT_TYPES.VIDEO:
        {
          // Most libraries block access to third party sites (eg. youtube) on their terminals, so users can't watch videos.
          // Unless the library allows watching videos on terminals.
          return library.get('localBranchEnableVideos') || !localBranch;
        }

      default:
        return true;
    }
  }

  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-ugc/lib/index.js
// module id = 121
// module chunks = 1